import React, { FC, useEffect, useState } from 'react';
import { ITSkillPopup } from 'core/interface/itSkill';
import ITSkills from '../../ITskill/Index';
import { ISkills } from 'core/interface/skills';
import { FormikValues } from 'formik';

import './Index.scss';

const ITSkillsPopup: FC<ITSkillPopup> = ({
  t,
  skill,
  showAddButton = false,
  skillType,
  handleClose
}) => {
  const [skills, setSkills] = useState<ISkills[]>([]);

  useEffect(() => {
    if (skill) setSkills(skill);
  }, [skill]);

  const handleAddExtraSkill = (values: FormikValues | undefined) => {
    // Preserve existing skills from form values
    const existingSkills =
      values?.skills?.map((item: any) => ({
        description: item.description || '',
        id: item.id || -1,
        proficiency: item.proficiency || 0,
        skill: {
          id: item.id || '',
          name: item.computerSkill || ''
        }
      })) || [];

    // Add new empty skill
    const newSkill: ISkills = {
      description: '',
      id: -1,
      proficiency: 0,
      skill: {
        id: '',
        name: ''
      }
    };

    // Update state with both existing and new skills
    setSkills([...existingSkills, newSkill]);
  };

  return (
    <div className="itSkills">
      <ITSkills
        skill={skills}
        skillType={skillType}
        t={t}
        handleAddExtraSkill={(skills) => handleAddExtraSkill(skills)}
        showAddButton={showAddButton}
        handleClose={handleClose}
      />
    </div>
  );
};

export default ITSkillsPopup;
